export default "__VITE_ASSET__BG5spcj0__"